__webpack_require__.p = "/frontend_static/";